<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';
import { usePublicPageBreadcrumb } from '@/composables/usePublicPageBreadcrumb';

const { t, tm, rt } = useI18n();
usePublicPageBreadcrumb('terms', 'pages.terms.title');
</script>

<template>
    <Head :title="t('pages.terms.title')">
        <meta name="description" :content="t('pages.terms.metaDescription')" />
    </Head>

    <div class="mx-auto max-w-3xl px-4 py-16">
        <h1 class="text-3xl font-semibold tracking-tight">{{ t('pages.terms.title') }}</h1>
        <p class="mt-2 text-sm text-muted-foreground">{{ t('pages.terms.lastUpdated') }}</p>

        <div class="mt-10 space-y-8 text-sm leading-relaxed text-muted-foreground">
            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.definitions.title') }}</h2>
                <ul class="mt-3 space-y-2">
                    <li v-for="(item, i) in (tm('pages.terms.sections.definitions.items') as any[])" :key="i"><strong class="text-foreground">{{ rt(item.term) }}:</strong> {{ rt(item.definition) }}</li>
                </ul>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.applicability.title') }}</h2>
                <p>{{ t('pages.terms.sections.applicability.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.service.title') }}</h2>
                <p>{{ t('pages.terms.sections.service.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.service.body2') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.account.title') }}</h2>
                <p>{{ t('pages.terms.sections.account.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.account.body2') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.fees.title') }}</h2>
                <p>{{ t('pages.terms.sections.fees.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.fees.body2') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.fees.body3') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.mandates.title') }}</h2>
                <p>{{ t('pages.terms.sections.mandates.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.mandates.body2') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.termination.title') }}</h2>
                <p>{{ t('pages.terms.sections.termination.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.termination.body2') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.availability.title') }}</h2>
                <p>{{ t('pages.terms.sections.availability.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.liability.title') }}</h2>
                <p>{{ t('pages.terms.sections.liability.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.liability.body2') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.liability.body3') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.prohibitedUse.title') }}</h2>
                <p>{{ t('pages.terms.sections.prohibitedUse.body') }}</p>
                <ul class="mt-2 list-disc pl-5 space-y-1">
                    <li v-for="(item, i) in (tm('pages.terms.sections.prohibitedUse.items') as string[])" :key="i">{{ rt(item) }}</li>
                </ul>
                <p class="mt-2">{{ t('pages.terms.sections.prohibitedUse.body2') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.intellectualProperty.title') }}</h2>
                <p>{{ t('pages.terms.sections.intellectualProperty.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.purchases.title') }}</h2>
                <p>{{ t('pages.terms.sections.purchases.body') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.purchases.body2') }}</p>
                <p class="mt-2">{{ t('pages.terms.sections.purchases.body3') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.privacy.title') }}</h2>
                <p>{{ t('pages.terms.sections.privacy.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.changes.title') }}</h2>
                <p>{{ t('pages.terms.sections.changes.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.governingLaw.title') }}</h2>
                <p>{{ t('pages.terms.sections.governingLaw.body') }}</p>
            </section>

            <section>
                <h2 class="text-lg font-medium text-foreground">{{ t('pages.terms.sections.contact.title') }}</h2>
                <p>{{ t('pages.terms.sections.contact.body') }}</p>
            </section>
        </div>
    </div>
</template>
